import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import PropTypes from "prop-types";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/aensa/Farmanimalbanner.jpeg";
import aensaLogo from "assets/images/aensa/new_logo_aensa_transparent.png";
import { useCallback } from "react";
import { Login } from "rest/requests";
import swal from "sweetalert";

import { ConfirmationCode } from "./confirmationCode";
import { useNavigate } from "react-router-dom";

function LogIn({ setUserData }) {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [isConfirming, setIsConfirming] = useState(false);
  const navigate = useNavigate();

  const loginRequest = useCallback(async () => {
    try {
      await Login(user, password);
      console.log("ok");
      setIsConfirming(true);
    } catch {
      console.log("error");
      setIsConfirming(false);
      swal("Error accediendo al sistema", "Usuario o contraseña incorrecto", "error");
    }
  }, [user, password]);

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="dark"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDBox
            key="logo"
            component="img"
            id="logo"
            src={aensaLogo}
            alt={"Aensa Logo "}
            width="30%"
            height="30%"
            bgColor="light"
            borderRadius="lg"
            coloredShadow="dark"
            shadow="lg"
          />
          <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
            Bienvenido a EMEVET
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Ingrese correo electronico y contraseña
          </MDTypography>
        </MDBox>
        {isConfirming ? (
          <ConfirmationCode
            setIsConfirming={setIsConfirming}
            user={user}
            setUserData={setUserData}
          />
        ) : (
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <MDInput
                  type="email"
                  label="Correo Electronico"
                  variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={(event) => setUser(event.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label="Clave de Acceso"
                  variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </MDBox>

              <MDBox mt={4} mb={1}>
                <MDButton variant="outlined" color="dark" fullWidth onClick={() => loginRequest()}>
                  Acceder
                </MDButton>
              </MDBox>
              <MDBox mt={3} mb={1} textAlign="center">
                <MDButton
                  variant="text"
                  onClick={() => {
                    navigate("/forgot_password", { replace: true });
                  }}
                >
                  <MDTypography variant="caption" color="text" size="small">
                    * Olvido su contraseña?
                  </MDTypography>
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        )}
      </Card>
      <br></br>
    </CoverLayout>
  );
}

LogIn.defaultProps = {
  setUserData: null
};

LogIn.propTypes = {
  setUserData: PropTypes.func
};

export default LogIn;
